module.exports = __webpack_public_path__ + "img/myachin.e02663e5.png";